<header class="top-header">
  <div class="header-left">
    <a routerLink="/dash" class="logo-link">
      <img class="header-logo" [src]="'/images/branding/' + tenant.company + '/header-logo.png'"
           [alt]="tenant.companyName"
           (error)="$any($event.target).style.display='none'" />
      <span class="company-name-fallback">{{ tenant.companyName }}</span>
    </a>
  </div>

  <div class="header-center">
    <form (ngSubmit)="onSearch()" class="search-form">
      <input type="text" [(ngModel)]="searchText" name="search"
             maxlength="23"
             placeholder="Search here..." class="search-input"
             (input)="onSearchInput()"
             (focus)="onSearchFocus()"
             autocomplete="off">
      <button type="submit" class="search-btn"><i class="pi pi-search"></i></button>
      <button type="button" class="search-dropdown-btn" (click)="toggleSearchOptions($event)">
        <i class="pi pi-chevron-down"></i>
      </button>

      <!-- Search options dropdown (tree checkboxes) -->
      @if (showSearchOptions) {
        <div class="search-options-dropdown" (click)="$event.stopPropagation()">
          @for (section of searchList; track section.name) {
            <div class="so-item so-parent" (click)="toggleNode(section, $event)">
              <i [ngClass]="getCheckIcon(section)"></i> {{ section.name }}
            </div>
            @if (section.children) {
              @for (child of section.children; track child.key) {
                <div class="so-item so-child" (click)="toggleNode(child, $event)">
                  <i [ngClass]="getCheckIcon(child)"></i> {{ child.name }}
                </div>
              }
            }
          }
          @if (searchList.length === 0) {
            <div class="so-empty">No search options available</div>
          }
        </div>
      }

      <!-- Live search results dropdown -->
      @if (showLiveResults) {
        <div class="live-results-dropdown">
          @if (liveLoading) {
            <div class="lr-loading"><i class="pi pi-spin pi-spinner"></i> Loading...</div>
          } @else {
            @for (item of liveResults; track $index) {
              <div class="lr-item" (mousedown)="goToResult(item)">
                <i [ngClass]="getResultIcon(item.type)"></i>
                <span>{{ getResultPrefix(item.type) }} {{ getResultDisplay(item) }}</span>
              </div>
            }
            <div class="lr-item lr-viewall" (mousedown)="onSearch()">
              <strong>View All</strong>
            </div>
          }
        </div>
      }
    </form>
  </div>

  <div class="header-right">
    <!-- New Quote button (V1: #aNewQuote — used to be a dropdown, now opens directly) -->
    @if (perms.catalogView) {
      <button class="new-quote-btn" (click)="newQuote()">
        <i class="pi pi-plus"></i>
        <span>New Quote</span>
      </button>
    }

    <!-- Cart/active-quote dropdown (V1: #currentQuoteButton + ul.dropdown-notification).
         Hidden entirely when there's no active quote — the +New Quote button next
         to it covers that case. -->
    @if (hasQuote) {
    <div class="cart-wrap">
      <button class="cart-btn" (click)="toggleCartDropdown($event)">
        {{ quoteItemCount }} Items (<strong>{{ quoteTotal | currency }}</strong>)
        | QT #: {{ viewQuote?.quote_id }}
      </button>

      @if (showCartDropdown) {
        <ul class="hd-dropdown cart-dropdown" (click)="$event.stopPropagation()">
          <li class="cart-dd-header">
            <button class="cart-go-btn" (click)="goToQuote()">Go to Quote</button>
          </li>
          @for (line of viewQuote.Lines; track line.EcomUpdateKey || $index) {
            <li class="cart-line">
              <div class="cart-line-top">
                <span class="cart-line-sku">{{ line.qty }} - <strong>{{ line.part_nr }}</strong></span>
                @if (!isPriceDenied(line)) {
                  <span class="cart-line-price">{{ line.price | currency }}</span>
                } @else if (line.prmsg?.length) {
                  <span class="cart-line-warn" [title]="line.prmsg">
                    <i class="pi pi-exclamation-triangle"></i>
                  </span>
                }
              </div>
              @if (line.description) {
                <div class="cart-line-desc">{{ line.description }}</div>
              }
            </li>
          }
          @if (!viewQuote?.Lines?.length) {
            <li class="cart-empty">No items in this quote yet.</li>
          }
        </ul>
      }
    </div>
    }

    <span class="user-name">{{ userName }}</span>
    <button class="logout-btn" (click)="logout()">Log Out</button>
  </div>
</header>
